/* @flow */
import * as React from 'react';
import Modal from 'react-modal';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import ConfirmDialog from 'components/ConfirmDialog';
import CanvasLTICredentials from './CanvasLTICredentials';

type State = {
  isConfirmationDialogOpened: boolean,
};

type Props = {
  onRequestHide: Function,
  rotateCredentials: Function,
};

class CanvasLTICredentialsModal extends React.Component<Props, State> {
  state: State = {
    isConfirmationDialogOpened: false,
  };

  handleRequestHide = () => {
    this.setState({ isConfirmationDialogOpened: true });
  };

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.isConfirmationDialogOpened}>
          <ConfirmDialog
            size="small"
            actionButtonText="Exit"
            cancelButtonText="Cancel"
            title="Are you sure you want to exit?"
            onConfirm={() => this.props.onRequestHide()}
            onRequestHide={() => this.props.onRequestHide()}
            onCancel={() => this.setState({ isConfirmationDialogOpened: false })}
            subtext="You will only be able to view your username and password for this set of credentials once."
          />
        </Modal>
        <Dialog onRequestHide={this.handleRequestHide}>
          <BoxBody>
            <CanvasLTICredentials rotateOnMount rotateCredentials={this.props.rotateCredentials} />
          </BoxBody>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default CanvasLTICredentialsModal;
